import { useTranslation } from 'react-i18next'

export default function SleepPhaseBar({ log }) {
  const { t } = useTranslation()
  const phases = [
    { key: 'deep', minutes: log.sleep_deep_minutes, color: 'bg-indigo-600', label: t('activity.deepSleep', 'Deep') },
    { key: 'light', minutes: log.sleep_light_minutes, color: 'bg-blue-400', label: t('activity.lightSleep', 'Light') },
    { key: 'rem', minutes: log.sleep_rem_minutes, color: 'bg-purple-500', label: t('activity.remSleep', 'REM') },
    { key: 'awake', minutes: log.sleep_awake_minutes, color: 'bg-amber-400', label: t('activity.awakeSleep', 'Awake') },
  ].filter((p) => p.minutes != null && p.minutes > 0)

  if (phases.length === 0) return null

  const total = phases.reduce((sum, p) => sum + p.minutes, 0)

  const formatDuration = (mins) => {
    const h = Math.floor(mins / 60)
    const m = mins % 60
    return h > 0 ? `${h}h ${m}m` : `${m}m`
  }

  return (
    <div>
      {/* Stacked bar */}
      <div className="flex h-4 rounded-full overflow-hidden mb-2">
        {phases.map((p) => (
          <div
            key={p.key}
            className={`${p.color} transition-all`}
            style={{ width: `${(p.minutes / total) * 100}%` }}
            title={`${p.label}: ${formatDuration(p.minutes)}`}
          />
        ))}
      </div>
      {/* Legend */}
      <div className="flex flex-wrap gap-3 text-xs">
        {phases.map((p) => (
          <div key={p.key} className="flex items-center gap-1">
            <div className={`w-2 h-2 rounded-full ${p.color}`} />
            <span className="text-gray-600">{p.label}</span>
            <span className="font-medium text-gray-700">{formatDuration(p.minutes)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
